import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';

import "react-confirm-alert/src/react-confirm-alert.css";


function FixPseq() {
  const navigate = useNavigate();

  const [idDistributor, setIDDistributor] = useState(''); 
  const [idHari, setIDHari] = useState('');
  const [idMinggu, setIDMinggu] = useState('');
  const [idTanggal, setIDTanggal] = useState('');
  const [idCallPlan, setIDCallPlan] = useState('');
  const [idSalesmanList, setIdSalesmanList] = useState([]);
  const [passwordAuth, setPasswordAuth] = useState('');

  const backFunction = () => {
    navigate('/');
  };

  const addIdSalesman = (e) => {
    const value = e.target.value.trim().toUpperCase();
    if (value === '') return;

    if (!idSalesmanList.includes(value)){
      setIdSalesmanList((prevList) => [...prevList, value]);
    }
    else{
      alert("sudah ditambahkan sebelumnya, tidak bisa yang sama");
    }
   
    e.target.value = '';
  };

  const removeIdSalesman = (index) => {
    setIdSalesmanList((prevList) => prevList.filter((_, i) => i !== index));
  };

  const submit = () => {
    if (idDistributor === '' || idHari === '' || idMinggu === '' || idCallPlan === '' || idTanggal === '') {
      alert('Isilah semua data terlebih dahulu');
      return;
    }
    confirmAlert({
      title: 'Konfirmasi Ulang',
      message: (
        <span>
           Pastikan data lagi, 
          dan sudah <b style={{ color: "red" }}>klik enter setiap ada salesman filter </b>, 
          Tanggal dipilih : {idTanggal}
        </span>
      
      ),
      buttons: [
        { label: 'Yes', onClick: () => setupPSEQAPI() },
        { label: 'No', onClick: () => null },
      ],
    });
  };

  const setupPSEQAPI = async ()=>{
    const requestBody = {
      "idDistributor" : idDistributor ,
      "idCallPlan" : idCallPlan,
      "idHari" : +idHari, 
      "idMinggu" : +idMinggu,
      "tanggal": idTanggal,
      "idSalesman" : idSalesmanList,
      "passwordAuth" : passwordAuth,
    };
    console.log(JSON.stringify(requestBody));

    try {
      const response = await fetch("https://api-sfasan.spsbijag.com/backend/backend_new/ScriptManagement/update_pseq.php",{
        mode : 'cors', 
        method : 'POST', 
        headers : {'Content-Type' : 'application/json'},
        body : JSON.stringify(requestBody)
      })

      const data = await response.json();
      //console.log("API Response (raw JSON):", JSON.stringify(data, null, 2));
      if (data.status === "success"){
        alert("Sukses untuk mengupdate data yang ada");
        navigate('/');
      }
      else{
        console.log("Error, tidak dapat mengubah PSEQ yang ada");
      }
    }
    catch(exception){
      alert(`Ada Error Terjadi : ${exception}`);
    }
  }
  

  return (
    <div className='App'>
      <header className='App-header'>
        <button className="back-button" onClick={backFunction}>
          <FontAwesomeIcon icon={faArrowLeft} />
          back
        </button>
        <h1>Fix PSEQ Mengikuti Aturan CallPlan</h1>
        <h5>
          Jangan lupa klik <b style={{ color: "red" }}>Enter pada keyboard</b> Sebelum Memasukkan
        </h5>
        <small style={{ display: "block", marginBottom: "50px" }}>
          <b style={{ color: "red" }}>Untuk SUN, input salesman satu per satu</b>
        </small>


        
        <div className='input-row'>
            <h5>Password</h5>
            <input
              type = "password"
              className="input-white"
              name="idDistributor"
              value={passwordAuth}
              onChange={(e) => setPasswordAuth(e.target.value)}
            />
        </div>


        <div className='input-row'>
          <div className='input-row'>
            <h5>ID Distributor</h5>
            <input
              className="input-white"
              name="idDistributor"
              maxLength={5}
              value={idDistributor}
              onChange={(e) => setIDDistributor(e.target.value)}
            />
          </div>

          <div className='input-row'>
            <h5>ID CallPlan</h5>
            <input
              className="input-white"
              name="idCallPlan"
              type="number"
              value={idCallPlan}
              onChange={(e) => setIDCallPlan(e.target.value)}
            />
          </div>


        </div>
          
        <div class = 'input-row'>
          <div className='input-row'>
            <h5>ID Hari</h5>
            <input
              className="input-white"
              name="idHari"
              maxLength={1}
              value={idHari}
              onChange={(e) => {
                const value = e.target.value;
                if (value === '' || (value >= 1 && value <= 7)) {
                  setIDHari(value);
                }
              }}
            />
          </div>

          <div className='input-row'>
            <h5>ID Minggu</h5>
            <input
              className="input-white"
              name="idMinggu"
              maxLength={1}
              value={idMinggu}
              onChange={(e) => {
                const value = e.target.value;
                if (value === '' || (value >= 1 && value <= 4)) {
                  setIDMinggu(value);
                }
              }}
            />
          </div>

        </div>

        <div className='input-row'>
          <h5>Tanggal</h5>
          <input
            className="input-white"
            name="TanggalCallPlan"
            type="date"
            value={idTanggal}
            onChange={(e) => setIDTanggal(e.target.value)}
          />
        </div>

        <div className='input-row'>
          <h5>ID Salesman</h5>
          <input
            maxLength={8}
            className="input-white"
            name="idSalesman"
            placeholder="Add Salesman (Enter)"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (e.target.value.length === 8){
                  addIdSalesman(e);
                }
                else{
                  alert("Harus 8 karakter");
                }
                
              }
            }}
          />
        </div>

        <div className='salesman-list'>
          <h5>Daftar ID Salesman</h5>
          <div className='salesman-items-row'>
          {idSalesmanList.length > 0 ? (
            idSalesmanList.map((idSalesman, index) => (
              <div key={`${idSalesman}-${index}`} className='salesman-item'>
                <span>{idSalesman}</span>
                <button onClick={() => removeIdSalesman(index)}>
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
            ))
          ) : (
            <p>Tidak ada ID Salesman</p>
          )}
          </div>
        </div>

        <button onClick={submit}>Update Pembenaran PSEQ</button>
      </header>
    </div>
  );
}

export default FixPseq;
